const transformedQuestionnaire = [
  {
    question:
      "Who is the person to attend the Assessment Meeting for This Business. Include all Information",
    answer: "",
    placeholder:
      "The person to attend this meeting is Mr./Miss. last name, first name. To reach them call 1-123-123-1234 their email is and the other information is...",
  },
  {
    question:
      "What are your primary business objectives for the next year? (e.g., revenue growth, market expansion, profitability improvement)",
    answer:
      "Our main goal for the next year is to achieve a 20% growth in revenue through effective market expansion strategies.",
    placeholder: "We aim to expand our market and increase revenue by X%.",
  },
  {
    question:
      "Are there any specific milestones or targets you want to achieve?",
    answer:
      "We're targeting to onboard 1000 new customers and launch a new product line by the end of the year.",
    placeholder:
      "We have set milestones to reach X number of customers and launch Y product by Z date.",
  },
  {
    question: "What does success look like for your business in the long term?",
    answer:
      "In the long term, we envision our business as a recognized leader in our industry, providing innovative solutions and maintaining a strong customer base.",
    placeholder:
      "Success for us means becoming an industry leader known for innovation and customer satisfaction.",
  },
  {
    question:
      "Can you provide an overview of your current financial position? (e.g., annual revenue, expenses, profit)",
    answer:
      "Currently, our annual revenue stands at $2 million, with expenses of $1.5 million, resulting in a profit of $500,000.",
    placeholder:
      "Our financial overview includes an annual revenue of $X million, expenses of $Y million, and a profit of $Z million.",
  },
  {
    question:
      "Do you have any existing financial and business reports? (e.g., balance sheets, income statements)",
    answer:
      "Yes, we have comprehensive financial reports, including balance sheets and income statements, which we use to assess our financial health.",
    placeholder:
      "We maintain financial reports such as balance sheets and income statements to evaluate our financial health.",
  },
  {
    question: "What are the challenges the business is facing right now?",
    answer:
      "Currently, we're experiencing challenges related to supply chain disruptions and increased competition in the market.",
    placeholder:
      "We're facing challenges such as X and Y, which are impacting our operations.",
  },
  {
    question:
      "Do you have a business growth plan or expansion strategy in place?",
    answer: "",
    placeholder:
      "Yes, we have a growth plan that includes opening a new location and launching an online store to reach a wider audience.",
  },
  {
    question: "How do you currently channel sales for your business?",
    answer: "",
    placeholder:
      "We primarily channel sales through our e-commerce website and also partner with local retailers.",
  },
  {
    question:
      "Is there anything else you'd like to share with us that you feel is important for the growth assessment?",
    answer:
      "We believe that focusing on customer retention will be crucial for our growth strategy.",
    placeholder:
      "We'd also like to emphasize the importance of customer retention for our growth.",
  },
  // ... (additional questions if needed)
];

export default transformedQuestionnaire;
